import axios from "@/libs/api.request";
// 获取列表
export const getBindFreight = params => {
  return axios.request({
    url: "/user/bindFreight",
    params,
    method: "get"
  });
};

export const readBindFreight = id => {
  return axios.request({
    url: `/user/bindFreight/readAuditLog/${id}`,
    method: "get"
  });
};

export const saveAudit = data => {
  return axios.request({
    url: `/user/bindFreight/handleAudit/${data.id}`,
    data,
    method: "post"
  });
};

export const batchHandleAudit = data => {
  return axios.request({
    url: `/user/bindFreight/batchHandleAudit`,
    data,
    method: "post"
  });
};
